module.exports = __webpack_public_path__ + "static/media/profileNew.895fb0b9.jpeg";